export enum SmartLabelPref {
	ENABLED = 'metadata.smartLabels.enabled',
}
